// extracted by mini-css-extract-plugin
module.exports = {"groupsList":"_2ob64EyN7c6WGb6s0C0iLS"};